import { createReducer } from 'typesafe-actions';
import { tabMenuAction, tabMenuState } from './types';

import {
  GO_TO_AI,
  GO_TO_RESULT,
  GO_TO_SIMILAR_IMAGE,
  GO_TO_IMAGE,
  SET_MENU_ID,
} from './actions';

const initialState: tabMenuState = {
  selectedMenuId: 0,
};

const reducer = createReducer<tabMenuState, tabMenuAction>(initialState, {
  [GO_TO_RESULT]: (state, action) => ({
    ...state,
    selectedMenuId: 0,
  }),
  [GO_TO_AI]: (state, action) => ({
    ...state,
    selectedMenuId: 1,
  }),
  [GO_TO_IMAGE]: (state, action) => ({
    ...state,
    selectedMenuId: 2,
  }),
  [GO_TO_SIMILAR_IMAGE]: (state, action) => ({
    ...state,
    selectedMenuId: 3,
  }),
  [SET_MENU_ID]: (state, action) => ({
    ...state,
    selectedMenuId: action.payload,
  }),
});

export default reducer;
